
import {  InfoCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col,  Input, Menu, Popconfirm, Row, Space, Table, Tooltip, message } from 'antd';
import dayjs from 'dayjs';
import "jspdf-autotable";
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Archive } from '../../Images/archive.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { deleteCustomer } from '../../slices/customer';

function ArchiveBundleOutWard() {
  let navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); // Track 
  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'bundle_number',
    'section',
    'length',
    'die_image',
    'item_name',
    'pieces',
    'weight',
    'avg',
    'packing_date',
    'customer',
    'alloy',
    'temper',
    'shift',
    'status',
    'gross_avg',
    'total_weight',
    'total_pieces',
    'total_bundles',
    'dispatch_date',
    'packing_type',
    'ship_no',
    'workorder_no',
    'date_prepared',
    'shift',
    'customer',
    'transpoter_name',
    'vehicle_no',
    'packed_by',
    'action',
  ]);

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };

  const handleDelete = (id) => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }

    dispatch(deleteCustomer(id))
      .unwrap()
      .then(() => {
        message.success('Customer Archive Successfully!');
      })
      .catch((error) => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo', // Use a unique key for the serial number
      key: 'SrNo',
      sorter: true,
      width: '8%',
    },
    {
      title: 'Ship No',
      dataIndex: 'slip_no',
      key: 'slip_no',
      sorter: true,
    },
    {
      title: 'Work Order Number',
      dataIndex: 'workorder',
      key: 'workorder',
      sorter: true,
      render: workorder => <span>{workorder?.order_no ?? 'N/A'}</span>,
    },
    {
      title: 'Date Prepared',
      dataIndex: 'date_prepared',
      key: 'date_prepared',
      render: date_prepared => {
        return (
          <span>{dayjs(date_prepared).format('DD-MM-YYYY') || 'N/A'} </span>
        );
      },
    },
    {
      title: 'Shift',
      dataIndex: 'shift',
      key: 'shift',
      sorter: true,
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer',
      key: 'customer',
      sorter: true,
      render: customer => {
        return <span>{customer?.customer_name || 'N/A'} </span>;
      },
    },
    {
      title: 'Total Weight(kg)',
      dataIndex: 'total_weight',
      key: 'total_weight',
      sorter: true,
    },
    {
      title: 'Total Pieces',
      dataIndex: 'total_pieces',
      key: 'total_pieces',
    },
    {
      title: 'Total Bundles',
      dataIndex: 'total_bundles',
      key: 'total_bundles',
    },
    {
      title: 'Transpoter Name',
      dataIndex: 'transporter_name',
      key: 'transporter_name',
    },
    {
      title: 'Vehicle No.',
      dataIndex: 'vehicle_no',
      key: 'vehicle_no',
    },
    {
      title: 'Packing Type / Status',
      dataIndex: 'packing_type',
      key: 'packing_type',
      render: (packing_type, record) => {
        const status = record?.status || 'N/A';
        const packingTypes = Array.isArray(record)
          ? record.workorder.packing_type.join(', ')
          : record.workorder.packing_type || 'N/A';
        return <span>{`${packingTypes} / ${status}`}</span>;
      },
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      render: (record) => {
        return (
          <span>{record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      sorter: true,
      render: (record) => {
        return (
          <span>{record ? `${record.first_name} ${record.last_name}` : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      sorter: true,
      render: (record) => {
        return (
          <span>{record && record.trim() ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}</span>
        );
      }
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      sorter: true,
      render: (record) => {
        return (
          <span>
            {record && record.first_name?.trim() && record.last_name?.trim()
              ? `${record.first_name} ${record.last_name}`
              : 'N/A'}
          </span>
        );
      }
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">


          <Tooltip placement="top" title={'Edit'} >
            <InfoCircleOutlined style={{ cursor: 'pointer' }} />
          </Tooltip>

          <Link>
            <Tooltip title='Archive'>
              <Popconfirm
                title="Are you sure you want to archive this record?"
                onConfirm={() => handleDelete(record.id)} // Correctly access `id`
                onCancel={() => message.info('Action cancelled')}
                okText="Yes"
                cancelText="No"
              >
                <Archive style={{ cursor: 'pointer' }} />
              </Popconfirm>
            </Tooltip>
          </Link>

        </Space>
      ),
    },
  ];
  const filteredColumns = columns.filter(column =>
    checkedList.includes(column.key),
  );

  const rowSelection = {
    selectedRowKeys,
    onChange: selectedRowKeys => setSelectedRowKeys(selectedRowKeys),
  };

  const dispatch = useDispatch();
  const { data = [], totalRecord, status } = useSelector(state => state.customer);
  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);

  const dataSource = data.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
  }));
  

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
    setPageSize(pagination.pageSize);
  };
  const debounceTimeout = useRef(null);

  const handleSearch = (e) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      setSearch(e.target.value);
      setPage(1);
    }, 100); // 300ms delay
  };
  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  const handlePageChange = newPage => {
    setPage(newPage);
    setOrderBy('')
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "pan_number" && sortOrder === "ascend") {
      sortingEnumKey = "pan_number";
    }
    if (sortField === "pan_number" && sortOrder === "descend") {
      sortingEnumKey = "-pan_number";
    }
    if (sortField === "gstin_number" && sortOrder === "ascend") {
      sortingEnumKey = "gstin_number";
    }
    if (sortField === "gstin_number" && sortOrder === "descend") {
      sortingEnumKey = "-gstin_number";
    }
    if (sortField === "udyam_no" && sortOrder === "ascend") {
      sortingEnumKey = "udyam_no";
    }
    if (sortField === "udyam_no" && sortOrder === "descend") {
      sortingEnumKey = "-udyam_no";
    }
    if (sortField === "customer_name" && sortOrder === "ascend") {
      sortingEnumKey = "customer_name";
    }
    if (sortField === "customer_name" && sortOrder === "descend") {
      sortingEnumKey = "-customer_name";
    }
    if (sortField === "phone_number" && sortOrder === "ascend") {
      sortingEnumKey = "phone_number";
    }
    if (sortField === "phone_number" && sortOrder === "descend") {
      sortingEnumKey = "-phone_number";
    }
    if (sortField === "created_at" && sortOrder === "ascend") {
      sortingEnumKey = "created_at";
    }
    if (sortField === "created_at" && sortOrder === "descend") {
      sortingEnumKey = "-created_at";
    }
    if (sortField === "created_by" && sortOrder === "ascend") {
      sortingEnumKey = "created_by";
    }
    if (sortField === "created_by" && sortOrder === "descend") {
      sortingEnumKey = "-created_by";
    }
    if (sortField === "updated_at" && sortOrder === "ascend") {
      sortingEnumKey = "updated_at";
    }
    if (sortField === "updated_at" && sortOrder === "descend") {
      sortingEnumKey = "-updated_at";
    }
    if (sortField === "updated_by" && sortOrder === "ascend") {
      sortingEnumKey = "updated_by";
    }
    if (sortField === "updated_by" && sortOrder === "descend") {
      sortingEnumKey = "-updated_by";
    }
    return sortingEnumKey;
  };

  const resetFilter = () => {
    setSearch('');
    setOrderBy('');
    setPage(1);
  };
  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group value={checkedList} onChange={handleColumnVisibilityChange}>
          <Row gutter={16}>
            <Col xs={24} md={12} >
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="ship_no">Ship No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="workorder_no">Work Order No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="date_prepared">Date Prepared</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="shift">Shift</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="customer">Customer Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_weight">Total Weight</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_pieces">Total Pieces</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_bundles">Total Bundles</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="transpoter_name">Transporter Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="vehicle_no">Vehicle No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="packing_type">Packing Type</Checkbox>
            </Col>

            <Col xs={24} md={12}>
              <Checkbox value="created_at">Created At</Checkbox>
            </Col>

            <Col xs={24} md={12} >
              <Checkbox value="created_by"  >
                Created By
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_at">Updated At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_by">Updated By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <div className='sticyaction'>
        <div className='sticky-header'>
          <Row
            className="pagenamerow mb-0 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2 style={{ margin: 0 }}>Archived Bundle Outward</h2>
              <div className="bredcrumbwrp">
                <Link to="/bundle-outward" className="back">
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: <Link to='/bundle-outward'>Bundle Outward</Link> },
                    { title: 'Archived Bundle Outward' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <Space size="small">
                <Input
                  placeholder="Search"
                  className='searchbox'
                  prefix={<SearchOutlined />}
                  value={search}
                  onChange={handleSearch}
                  style={{ width: '100%' }}
                />
                <Tooltip title="Filter">
                  <Button
                    type="primary"
                    disabled={!search && !orderBy}
                    className="iconlink"
                    onClick={resetFilter}
                  >
                    <FilterIcon />
                  </Button>
                </Tooltip>

              </Space>
            </Col>
          </Row>
        </div>
      </div>
      <div style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fff' }}>

      <Table
        rowKey="id"
        rowSelection={rowSelection}
        columns={filteredColumns}
        dataSource={dataSource}
        pagination={{
          defaultCurrent: page,
          defaultPageSize: pagesize,
          total: totalRecord,
          showTotal: (total) => `Total ${total} items`,
          showSizeChanger: true,
          onChange: handlePageChange,
          locale: {
            items_per_page: 'Items / Page', // Text for the size changer
          },
        }}
        onChange={handleTableChange}
        loading={status === 'loading'}
        scroll={{ x: '600px' }}      />
</div>
    </div>
  );
}

export default ArchiveBundleOutWard
